import { useEffect, useMemo } from 'react';
import { SWRConfiguration, SWRResponse, useSWRConfig } from 'swr';import { useGet } from '@ngt/forms';
import { GetCheckoutSession, GetCheckoutSessionResponse } from '@/api/dtos';

const getData = (response?: SWRResponse<GetCheckoutSessionResponse, GetCheckoutSessionResponse>) => response?.data;
const getError = (response?: SWRResponse<GetCheckoutSessionResponse, GetCheckoutSessionResponse>) => (response?.error ?? response?.data)?.responseStatus;

const useCheckoutSession = (amount: number, email: string | undefined, configuration: SWRConfiguration = { 

}) => {

    const request = useMemo(() => {
        if (!amount || !email) {
            return undefined;
        }

        return () => {
            return new GetCheckoutSession({amount, email});
        }
    }, [email, amount]);

    const { cache } = useSWRConfig();

    useEffect(() => {
        return () => {
            // Delete the cached clientSecret on unmount so a subsequent mount fetches a
            // fresh session — Stripe rejects reuse with "You cannot have multiple
            // Embedded Checkout objects."
            // Note: mutate(..., undefined, { revalidate: false }) leaves the key in a
            // "resolved-undefined" state, causing SWR to skip fetching on next mount.
            // cache.delete removes the key entirely so the next mount fetches fresh.
            for (const key of cache.keys()) {
                if (typeof key === 'string' && key.includes('GetCheckoutSession')) {
                    cache.delete(key);
                }
            }
        };
    }, [cache]);

    return useGet(request, { getData, getError }, configuration)
}

export default useCheckoutSession;
